import { SEU_CANVAS_GRID_CELL_SIZE } from '@seu-types';

// Constants for stream drawing
// if these values are changed, also adjust spacing in tailwind.config.js (canvas-component)
export const SEU_CANVAS_COMPONENT_WIDTH = 168;
export const SEU_CANVAS_MIXER_SPLITTER_WIDTH = 128;
export const SEU_STREAM_HANDLE_OFFSET_X =
  (SEU_CANVAS_GRID_CELL_SIZE - SEU_CANVAS_COMPONENT_WIDTH) / 2;
export const SEU_STREAM_HANDLE_OFFSET_MIXER_SPLITTER_X =
  (SEU_CANVAS_GRID_CELL_SIZE - SEU_CANVAS_MIXER_SPLITTER_WIDTH) / 2;
export const SEU_STREAM_HANDLE_SIZE = 28;
export const SEU_INPUT_STREAM_OFFSET_BOTTOM = 78;
export const SEU_STREAM_FIRST_AND_LAST_ARROW_OFFSET = 28;
export const SEU_BORDER_STREAM_OFFSET = 10;
export const SEU_MIN_LENGTH_FOR_ARROW =
  SEU_CANVAS_GRID_CELL_SIZE / 2 - 2 * SEU_BORDER_STREAM_OFFSET;
